// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__oiMwZ","rootCenter":"LoadMoreObserver_rootCenter__2Q-ZN","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2KJtP"};